import { render, staticRenderFns } from "./intermediario.vue?vue&type=template&id=e54f388a&scoped=true"
import script from "./intermediario.vue?vue&type=script&lang=js"
export * from "./intermediario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54f388a",
  null
  
)

export default component.exports